import React from 'react';
import Link from './Link';
import Button from '../buttons/Button';
import fn from '../../helpers/fn';

export default fn(__filename, Button.extend`
  display: inline-block;
  text-decoration: none;
`.withComponent(({
  fluid, bold, standard, fixed, small, active, // strip
  ...props
}) => <Link {...props} />));



// WEBPACK FOOTER //
// ./src/components/links/ButtonLink.js